export const htmlEncode = (html = '') => html ? document.createElement('div').appendChild(document.createTextNode(html)).parentNode.innerHTML : html;
export const htmlDecode = (html = '') => html ? new DOMParser().parseFromString(html, 'text/html').documentElement.textContent : html;
